import React, { useState, useRef, useCallback, useEffect } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [fading, setFading] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleEnd = useCallback(() => {
    if (fading) return;
    setFading(true);
    setTimeout(onComplete, 600);
  }, [fading, onComplete]);

  // Auto-end after 2 seconds regardless of video length
  useEffect(() => {
    const timer = setTimeout(handleEnd, 2000);
    return () => clearTimeout(timer);
  }, [handleEnd]);

  const handleSkip = () => {
    if (videoRef.current) videoRef.current.pause();
    handleEnd();
  };

  // If video fails to load/play, skip the splash entirely
  const handleError = () => {
    onComplete();
  };

  return (
    <div
      className={`fixed inset-0 z-[99999] bg-black flex items-center justify-center transition-opacity duration-[600ms] ${
        fading ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <video
        ref={videoRef}
        src="/splash.mp4"
        autoPlay
        muted
        playsInline
        onEnded={handleEnd}
        onError={handleError}
        className="w-[90vw] max-h-[90vh] object-contain"
      />
      <button
        onClick={handleSkip}
        className="absolute bottom-8 right-8 text-white/60 hover:text-white text-sm px-4 py-2 border border-white/20 rounded-lg hover:border-white/40 transition-colors backdrop-blur-sm"
      >
        Skip
      </button>
    </div>
  );
};

export default SplashScreen;
